import React, { Component, useEffect } from 'react';
import Datas from '../data/icon-box/icon-box.json';
import { Container, Row, Col } from 'react-bootstrap';
import { Styles } from "./styles/iconBox.js";
import { useTranslation } from 'react-i18next'
import cookies from 'js-cookie';
import UserService from '../services/UserService';
import { useState } from 'react';
import service from '../services/service';
import { toast } from 'react-toastify';
import CountUp from 'react-countup';

const languages = [
    {
        code: 'en',
        name: 'English',
        country_code: 'gb',
    },
    {
        code: 'hi',
        name: 'Hindi',
        country_code: 'in'
    },
    {
        code: 'pu',
        name: 'Punjabi',
        country_code: 'in'
    },
]

function IconBox() {
    const { t } = useTranslation();

    // 1. Move the Default Data outside or to a constant so it can be used for initialization
    const initialIconBoxData = [
        {
            "id": "1",
            "uniqClass": "box-icon box1",
            "boxIcon": "las la-users",
            "title": "popular_courses",
            "subTitle": "0",
            "color": 'box1-color'
        },
        {
            "id": "2",
            "uniqClass": "box-icon box2",
            "boxIcon": "las la-book-open",
            "title": "modern_library",
            "subTitle": "0",
            "color": 'box2-color'
        },
        {
            "id": "3",
            "uniqClass": "box-icon box3",
            "boxIcon": "las la-trophy",
            "title": "qualified_teacher",
            "subTitle": "0",
            "color": 'box3-color'
        }
    ];

    const defaultCountState = {
        learnerCount: 0,
        instructorCount: 0,
        courseCount: 0,
        iconBoxData: initialIconBoxData // Initialize with data so it displays immediately
    }

    const [getCountState, setCountState] = useState(defaultCountState)

    useEffect(() => {
        UserService.generateToken();
        loadCount()
    }, []);

    const currentLanguageCode = cookies.get('i18next') || 'en'
    const currentLanguage = languages.find((l) => l.code === currentLanguageCode)

    useEffect(() => {
         document.body.dir = currentLanguage?.dir ?? "ltr";
        document.title = t('app_title')
    }, [currentLanguage, t])

    const loadCount = async () => {
        await service.getNumberOfCounts()
            .then(res => {
                if (res.data && Object.keys(res.data).length !== 0) {
                    const IconBoxData = [
                        {
                            "id": "1",
                            "uniqClass": "box-icon box1",
                            "boxIcon": "las la-users",
                            "title": "popular_courses",
                            "subTitle": `${(res.data.learnerCount || 0)}`,
                            "color": 'box1-color'
                        },
                        {
                            "id": "2",
                            "uniqClass": "box-icon box2",
                            "boxIcon": "las la-book-open",
                            "title": "modern_library",
                            "subTitle": `${(res.data.courseCount || 0)}`,
                            "color": 'box2-color'
                        },
                        // {
                        //     "id": "3",
                        //     "uniqClass": "box-icon box3",
                        //     "boxIcon": "las la-trophy",
                        //     "title": "qualified_teacher",
                        //     "subTitle": "372",
                        //     "color": 'box3-color'
                        // }
                    ]
                    setCountState((prevState) => ({
                        ...prevState,
                        learnerCount: res.data.learnerCount,
                        instructorCount: res.data.instructorCount,
                        courseCount: res.data.courseCount,
                        iconBoxData: IconBoxData
                    }))
                } else {
                    // If res.data is empty, we keep showing the initial state (already set)
                    setCountState(prevState => ({...prevState, iconBoxData: initialIconBoxData}));
                }
            }).catch((err) => {
                // toast.error("Server error")
                // On error, ensure the UI still has data to display
                setCountState(prevState => ({...prevState, iconBoxData: initialIconBoxData}));
            })
    }

    return (
        <Styles>
            {/* Icon Box */}
            <section className="icon-box-area">
                <Container>
                    {/* To get dynamic content use the below code */}
                    {/* <Row>
                        {
                            getCountState.iconBoxData?.map((data, i) => (
                                <Col md="4" key={i}>
                                    <div className="full-icon-box">
                                        <div className="icon-box d-flex">
                                            <div className={data.uniqClass}>
                                                <i className={data.boxIcon} style={{ fontSize: '50px' }}></i>
                                            </div>
                                            <div className="box-title">
                                                <h6>{t(data.title)}</h6>
                                                <h5 className='text-center font-weight-bold'>{t(data.subTitle)}</h5>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            ))
                        }
                    </Row> */}
                    <Row>
                        {
                            getCountState.iconBoxData?.map((data, i) => (
                                <Col md="6" key={i}>
                                    <div className="full-icon-box ">
                                        <div className="icon-box d-flex justify-content-center ">
                                            <div className={`${data.uniqClass} mb-3 mt-0`}>
                                                <i className={data.boxIcon} style={{ fontSize: '50px' }}></i>
                                            </div>
                                            <div className="box-title flex-grow text-center">
                                                <h6>{t(data.title)}</h6>
                                                <h3 className={`${data.color}`}>
                                                    <CountUp 
                                                        end={parseInt(data.subTitle)} 
                                                        duration={3} 
                                                        delay={0.5} 
                                                    />
                                                    <i className="las la-plus fa-xs"></i>
                                                </h3>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            ))
                        }
                    </Row>
                </Container>
            </section>
        </Styles>
    )
}

export default IconBox